import React from "react";
import useTitanApp from "../../../../../hooks/useTitanApp";
import "../../../../../assets/css/Vitals.scss";
import { Skeleton } from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Vitals() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { patientVitals, patientVitalsLoading } = patientState || {};

  const transformedData = patientVitals
    ? Object.entries(patientVitals)
        .filter(([_, value]) => value !== null)
        .reduce((acc, [key, value]) => {
          if (key === "bloodPressure") {
            const systolic = value.systolic ?? {};
            const diastolic = value.diastolic ?? {};

            acc.push({
              vitalName: "Blood Pressure",
              systolic: systolic.value ?? null,
              diastolic: diastolic.value ?? null,
              unit: systolic.unit || diastolic.unit || "mmHg",
              normalRange: `${systolic.normalRange ?? ""}/${
                diastolic.normalRange ?? ""
              }`,
              method: value.method ?? "",
              deviceUsed: systolic.deviceUsed || diastolic.deviceUsed || "",
              isNormal:
                systolic.isNormal === true && diastolic.isNormal === true,
              flagged: systolic.flagged === true || diastolic.flagged === true,
              category: value.category ?? "",
              position: value.position ?? "",
              armUsed: value.armUsed ?? "",
              cuffSize: value.cuffSize ?? "",
            });
          } else if (
            key !== "createdOn" &&
            key !== "updatedOn" &&
            key !== "isArchive" &&
            key !== "archiveOn"
          ) {
            acc.push({
              vitalName: key[0].toUpperCase() + key.slice(1),
              ...value,
            });
          }

          return acc;
        }, [])
    : [];
  const formatVitalLabel = (vitalName) => {
    switch (vitalName) {
      case "HeartRate":
        return "Heart Rate";
      case "Blood Pressure":
        return "Blood Pressure";
      case "RespiratoryRate":
        return "Respiratory Rate";
      case "Bmi":
        return "BMI";
      case "Weight":
        return "Weight";
      case "Temperature":
        return "Temperature";
      case "Height":
        return "Height";
      case "Circumference":
        return "Circumference";
      default:
        return vitalName; // fallback for any other vitals
    }
  };
  return (
    <div className="card-shaped-box">
      <div className="card-shaped-content">
        <div className="patient-dashboard-vitals-wrapper">
          <div className="patient-dashboard-vitals-list">
            {patientVitalsLoading
              ? Array.from({ length: 5 }).map((_, index) => (
                  <div key={index} className="list-item-sk">
                    <Skeleton
                      width={150}
                      height={50}
                      animation="wave"
                      sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                    />
                    <Skeleton
                      width={200}
                      height={30}
                      animation="wave"
                      sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                    />
                  </div>
                ))
              : transformedData.map((vitalDetails, index) => (
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="vital-value">
                        <p>
                          {vitalDetails.vitalName === "Blood Pressure"
                            ? `${vitalDetails.systolic}/${vitalDetails.diastolic}`
                            : vitalDetails.value}
                        </p>
                        <p>{vitalDetails.unit}</p>
                      </div>
                      <div className="vital-details">
                        <p>{formatVitalLabel(vitalDetails.vitalName)}</p>
                        <p>{`${
                          vitalDetails.vitalName === "Blood Pressure"
                            ? `${vitalDetails.systolic}/${vitalDetails.diastolic}`
                            : vitalDetails.value
                        }  ${vitalDetails.unit}`}</p>
                      </div>
                    </AccordionSummary>
                    {/* <AccordionDetails className="acc-details">
                      <div className="detail">
                        <p className="value">{vitalDetails.normalRange}</p>
                        <p className="label">Normal Range</p>
                      </div>
                      <div className="detail">
                        <p className="value">{vitalDetails.deviceUsed}</p>
                        <p className="label">Device Used</p>
                      </div>
                    </AccordionDetails> */}
                  </Accordion>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}
